module.exports = __webpack_public_path__ + "static/media/img-1.f150d76e.png";